import React, {useEffect, useState} from 'react'
import {useTranslation} from "react-i18next";
import Fade from "@mui/material/Fade";
import Card from "@mui/material/Card";
import {Collapse} from "@mui/material";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import { v4 as uuidv4 } from 'uuid';
import MDTypography from "../../../../components/MDTypography";
import MDBox from "../../../../components/MDBox";
import {onErrorAlert, onSuccessAlert} from "../../../../actions";
import OwnerDiscountList from "./OwnerDiscountList";
import {useDispatch} from "react-redux";
import {checkPermission, PERMISSION_DICT} from "../../../../utils/Users_Roles_Permission";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Button from "@mui/material/Button";

const OwnerDiscountInformation = ({info={},loading, setTotal,total,setList,list}) => {
    const [isOpen,setIsOpen] = useState(true)
    const {t} = useTranslation()
    const dispatch = useDispatch()

    const handleCellDoubleClick = (params) => {
        const textToCopy = params?.value;
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    dispatch(onSuccessAlert(`"${textToCopy}" ${t('copied')}`))
                })
                .catch((err) => {
                    dispatch(onErrorAlert(`${t('copy failed')}`))
                });
        }

    };


    return(<React.Fragment>
            <Fade in = {true}>
                <Card sx={{minWidth: 350}}>
                    <MDBox
                        mx={1}
                        mt={-3}
                        py={1}
                        px={2}
                        variant="gradient"
                        bgColor="light"
                        borderRadius="lg"
                        coloredShadow="light"
                        display={'flex'}
                        alignItems={'center'}
                        justifyContent={'space-between'}

                    >

                        <MDTypography variant="h6" >
                            {t('CustomerPage.Discount Information')}
                        </MDTypography>
                        <IconButton color={'white'}  disabled={loading}  size={'small'} onClick={()=>setIsOpen(!isOpen)}>
                            {(isOpen && !loading)?<Icon>expand_less</Icon>:<Icon>expand_more</Icon>}
                        </IconButton>


                    </MDBox>

                    <Collapse in={isOpen&& !loading} timeout={500}>
                        <MDBox pb={2} px={2} mt={2}>
                            <OwnerDiscountList info={info}
                                               setTotal={setTotal}
                                               total={total}
                                               setList={setList}
                                               list={list}
                            />

                        </MDBox>
                    </Collapse>

                </Card>
            </Fade>
        </React.Fragment>
    )
}

export default OwnerDiscountInformation